<template>
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div v-loading="isLoading" :element-loading-text="'当前控制模式切换中，时间较长，请勿点击其它操作，耐心等待'" class="screen-all-container">
        <div class="seclece">
          <div>
            选择分组：
          </div>
          <el-select @change="getId" v-model="value" placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.groupName" :value="item.id"> </el-option>
          </el-select>
          <div style="margin-left:20px">
            控制模式：
          </div>
          <el-select @change="handleStatus_($event)" v-model="devicId_" placeholder="请选择">
            <el-option label="远程控制模式" :value="0"> </el-option>
            <el-option label="定时控制模式" :value="1"> </el-option>
            <el-option label="AI自动模式" :value="2"> </el-option>
          </el-select>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="el-tab_top">
          <el-tab-pane label="空气温度" name="4" style="margin-right: 30px">
            <draughtFan_ ref="table" :devicId_="devicId_" @getUserMessageList="getUserMessageList" :value="value" :tableData="tableData" :tableData_list='tableData_list' :table='table' :activeName="activeName"></draughtFan_>
          </el-tab-pane>
          <el-tab-pane label="空气湿度" name="5">
            <draughtFan_ ref="table" :devicId_="devicId_" @getUserMessageList="getUserMessageList" :value="value" :tableData="tableData" :tableData_list='tableData_list' :table='table' :activeName="activeName"></draughtFan_>
          </el-tab-pane>
          <el-tab-pane label="CO2浓度" name="2">
            <draughtFan ref="table" :devicId_="devicId_" @getUserMessageList="getUserMessageList" :value="value" :tableData="tableData" :tableData_list='tableData_list' :table='table' :activeName="activeName"></draughtFan>
          </el-tab-pane>
          <el-tab-pane label="土壤湿度" name="1">
            <draughtFan ref="table" :devicId_="devicId_" @getUserMessageList="getUserMessageList" :value="value" :tableData="tableData" :tableData_list='tableData_list' :table='table' :activeName="activeName"></draughtFan>
          </el-tab-pane>
          <el-tab-pane label="光照强度" name="0">
            <draughtFan ref="table" :devicId_="devicId_" @getUserMessageList="getUserMessageList" :value="value" :tableData="tableData" :tableData_list='tableData_list' :table='table' :activeName="activeName"></draughtFan>
          </el-tab-pane>

          <!-- <el-tab-pane label="内风机" name="3">
            <draughtFan :value='value' :tableData='tableData' :activeName='activeName'></draughtFan>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>

    <div class="pagination-container">
      <div class="pagination-content-container"></div>
    </div>
  </div>
</template>
<script>
import draughtFan from './components/draughtFan'
import draughtFan_ from './components/draughtFan_1'

import approvalTemplate from '../approvalManagement/approvalTemplate'
import approvalConfiguration from '../approvalManagement/approvalConfiguration'
import approvalRecord from '../approvalManagement/approvalRecord'
export default {
  name: 'userManagement',
  components: {
    draughtFan,
    draughtFan_,

    approvalConfiguration,
    approvalRecord,
    approvalTemplate
  },
  data() {
    return {
      activeName: '4',
      options: [],
      value: '',
      tableData: [],
      devicId_: '',
      timer: '',
      isLoading: false,
      table: [],
      tableData_list: []
    }
  },
  created() {
    this.getGrowthModelDecisionList()
    if (this.$route.query.currentShow != null) {
      this.activeName2 = this.$route.query.currentShow
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getBoxStatus()
    }, 10000)
    this.getUserDetails()
    setTimeout(() => { }, 1000)
  },
  // 销毁
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getBoxStatus() {
      var a = ''
      this.options.map(item => {
        if (item.id == this.value) {
          a = item.groupId
        }
      })
      this.$api.growthModel.getBoxStatus({ id: a }).then(res => {
        if (res.code == 200) {
          this.devicId_ = Math.round(res.data.value)
        }
      })
    },
    handleStatus_(val, id) {
      var a = ''
      this.options.map(item => {
        if (item.id == this.value) {
          a = item.groupId
        }
      })
      let data = {
        groupId: a,
        status: val
      }
      if (val != 2) {
        this.$api.growthModel.openOrCloseGrowthModelDecision({ groupId: a, status: 0, day: 0 })
      }
      this.$api.growthModel.changeBox(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.isLoading = true
          setTimeout(() => {
            this.isLoading = false
            this.getBoxStatus()
            this.$forceUpdate()
          }, 30000)
          // this.handleSearch()
        }
      })
    },
    //列表信息
    getUserMessageList() {
      this.$api.growthModel.getGrowthModelDecisionSchedules({ decisionId: this.value, type: this.activeName }).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      })
    },
    getGrowthModelDecisionScheduleComponets() {
      let form = {
        decisionId: this.value,
        type: this.activeName
      }
      this.$api.growthModel.getGrowthModelDecisionScheduleComponets(form).then(res => {
        if (res.code == 200) {
          this.tableData_list = []
          this.table = []
          if (res.data.length > 0) {
            let tableData_list = []
            res.data.map(item => {
              let a = {
                label: item.name,
                prop: item.code,
                deviceStatus: item.deviceStatus,
                id: item.id
              }
              tableData_list.push(a)
            })
            let arr = []
            tableData_list.map(item => {
              arr.push(item.deviceStatus.split(','))

            })
            let b = []
            arr[0].map((item, index) => {
              b.push(this.getFirstElements(arr, index))
              // console.log(this.getFirstElements(arr, index));
            })
            b.map(item => {
              let c = {}
              item.map((citem, index) => {
                c[index] = citem
              })
              this.table.push(c)
            })
            this.table.map((item, index) => {
              item.index = index + 1
            })
            console.log(this.table, 669);
            this.tableData_list = tableData_list
          } else {
            // this.tableData_list = []
            // this.table = []
          }


        }
      })
    },
    getFirstElements(arrays, i) {
      return arrays.map(array => array[i]);
    },
    getId(val) {
      this.value = val
      this.getUserMessageList()
      this.saveUserGroup(val)
      this.getGrowthModelDecisionScheduleComponets()
    },
    getUserDetails() {
      this.$api.system.getUserDetails(sessionStorage.getItem('USER_ID')).then(res => {
        if (res.code == 200) {

          sessionStorage.setItem('USER_groupID', res.data.groupId)
        }
      })
    },
    saveUserGroup(val) {
      let id = ''
      this.options.map(item => {
        if (item.id == val) {
          id = item.groupId
        }
      })
      this.$api.system.saveUserGroup({ id: id }).then(res => {
        if (res.code == 200) {
        }
      })
    },
    // 查询全部决策模型列表
    getGrowthModelDecisionList() {
      this.$api.growthModel
        .getGrowthModelDecisionList({
          pageNum: 1,
          pageSize: 20
        })
        .then(res => {
          this.isLoading = false
          if (res.code == 200) {
            this.options = res.data
            res.data.map((item, index) => {
              if (Number(sessionStorage.getItem('USER_groupID'))) {
                if (item.groupId == Number(sessionStorage.getItem('USER_groupID'))) {
                  this.value = item.id
                }
              } else {
                this.value = res.data[0].id
              }
            })
            this.getBoxStatus()
            this.getUserMessageList()
            this.getGrowthModelDecisionScheduleComponets()
          }
        })
    },
    handleClick() {
      this.getUserMessageList()
      this.getGrowthModelDecisionScheduleComponets()
      this.$refs.table.showType = true
    }
  }
}
</script>
<style scoped>
@import '../../style/userManagement.scss';
.seclece {
  margin: 20px;
  display: flex;
  align-items: center;
  color: #333;
  font-size: 14px;
}
</style>
